import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { constants, lodash as _ } from '../../../common';
import { buildSelectedMap, getTagName, getTagNo, normalizeTagName, sameTagSelection } from './issueTags';
import './tagging.scss';

const { tagTypes } = constants;

class IssueTagsDialog extends Component {
   constructor(props) {
      super(props);
      const current = buildSelectedMap(props.issue && props.issue.tags);
      this.state = { searchText: '', selected: current, current };
   }

   componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) this._reset(this.props);
      if (this.props.createCompletedAt && this.props.createCompletedAt !== prevProps.createCompletedAt) {
         const current = buildSelectedMap(this.props.issue && this.props.issue.tags);
         this.setState({ selected: current, current, searchText: '' });
      }
   }

   _reset = (props) => {
      const current = buildSelectedMap(props.issue && props.issue.tags);
      this.setState({ searchText: '', selected: current, current });
   };

   _issueTags = () => _.filter(this.props.tags || [], (tag) => {
      const noTag = getTagNo(tag);
      return noTag != null && !tag.deleted && (tag.noTagType == null || tag.noTagType === tagTypes.ISSUE.id);
   });

   _toggle = (tag) => {
      const key = String(getTagNo(tag));
      this.setState({ selected: { ...this.state.selected, [key]: !this.state.selected[key] } });
   };

   _selectedTags = () => _.filter(this._issueTags(), (tag) => this.state.selected[String(getTagNo(tag))]);

   _create = () => {
      const tagName = String(this.state.searchText || '').trim();
      const createdTag = this.props.onCreate(tagName);
      const noTag = getTagNo(createdTag);
      if (noTag != null) {
         this.setState({
            searchText: '',
            selected: { ...this.state.selected, [String(noTag)]: true }
         });
      }
   };

   render() {
      const { open, saving, creating, error, createError, allowCreate, onClose, onSave } = this.props;
      const issueTags = this._issueTags();
      const normalizedSearch = normalizeTagName(this.state.searchText);
      const trimmedSearch = String(this.state.searchText || '').trim();
      const filteredTags = normalizedSearch ? _.filter(issueTags, (tag) => normalizeTagName(getTagName(tag)).includes(normalizedSearch)) : issueTags;
      const exactMatch = normalizedSearch && _.some(issueTags, (tag) => normalizeTagName(getTagName(tag)) === normalizedSearch);
      const dirty = !sameTagSelection(this.state.current, this.state.selected);
      const canCreate = Boolean(trimmedSearch && !exactMatch && !dirty && !saving && !creating);
      const busy = saving || creating;

      return (
         <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth='sm'>
            <DialogTitle>Manage tags</DialogTitle>
            <DialogContent>
               <TextField
                  fullWidth
                  margin='normal'
                  label='Search issue tags'
                  value={this.state.searchText}
                  onChange={(event) => this.setState({ searchText: event.target.value })}
                  disabled={busy}
               />
               {error && <div className='issue-tags-error'>{error}</div>}
               {createError && <div className='issue-tags-error'>{createError}</div>}
               {allowCreate && trimmedSearch && !exactMatch && (
                  <div className='issue-tags-create'>
                     <div>
                        <strong>Create “{trimmedSearch}”</strong>
                        {dirty && <span>Save current tag changes before creating a new tag.</span>}
                     </div>
                     <Button color='primary' disabled={!canCreate} onClick={this._create}>
                        {creating ? 'Creating…' : 'Create'}
                     </Button>
                  </div>
               )}
               {!issueTags.length && <div className='issue-tags-empty'>No issue tags available</div>}
               {issueTags.length > 0 && !filteredTags.length && <div className='issue-tags-empty'>No issue tags found</div>}
               <List dense>
                  {filteredTags.map((tag) => {
                     const key = String(getTagNo(tag));
                     const checked = Boolean(this.state.selected[key]);
                     return (
                        <ListItem button key={`issue-tag-${key}`} selected={checked} disabled={busy} onClick={() => this._toggle(tag)}>
                           <ListItemText primary={getTagName(tag)} />
                           <ListItemSecondaryAction>
                              <Checkbox checked={checked} disabled={busy} onChange={() => this._toggle(tag)} />
                           </ListItemSecondaryAction>
                        </ListItem>
                     );
                  })}
               </List>
            </DialogContent>
            <DialogActions>
               <Button disabled={busy} onClick={onClose}>Cancel</Button>
               <Button color='primary' variant='contained' disabled={busy || !dirty} onClick={() => onSave(this._selectedTags())}>
                  {saving ? 'Saving…' : 'Save'}
               </Button>
            </DialogActions>
         </Dialog>
      );
   }
}

IssueTagsDialog.defaultProps = {
   allowCreate: true
};

IssueTagsDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   issue: PropTypes.object,
   tags: PropTypes.array,
   saving: PropTypes.bool,
   creating: PropTypes.bool,
   error: PropTypes.string,
   createError: PropTypes.string,
   createCompletedAt: PropTypes.number,
   allowCreate: PropTypes.bool,
   onClose: PropTypes.func.isRequired,
   onSave: PropTypes.func.isRequired,
   onCreate: PropTypes.func.isRequired
};

export default IssueTagsDialog;
